import PortalIdParser from 'PortalIdParser';
export const SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY = 'SELECTED_BUSINESS_UNIT';
export const ALL_BUSINESS_UNITS = 'ALL';
export const getSelectedBusinessUnitId = () => {
  let selectedBusinessUnitStorageValue;
  try {
    selectedBusinessUnitStorageValue = localStorage.getItem(SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY);
    if (selectedBusinessUnitStorageValue) {
      selectedBusinessUnitStorageValue = JSON.parse(selectedBusinessUnitStorageValue);
    }
  } catch (error) {
    selectedBusinessUnitStorageValue = undefined;
  }
  const portalId = PortalIdParser.get();
  if (selectedBusinessUnitStorageValue && portalId) {
    var _selectedBusinessUnit;
    // In rare case where customer owns multiple portals but only one has business units set up
    // They can still have the business unit key in the localStorage
    // But the portal they are currently on may return undefined, so we default to 'ALL'

    // Nullish coalescing operator (instead of ||) because a BU ID of 0 means the primary/account brand
    return (_selectedBusinessUnit = selectedBusinessUnitStorageValue[portalId]) !== null && _selectedBusinessUnit !== void 0 ? _selectedBusinessUnit : ALL_BUSINESS_UNITS;
  }
  return ALL_BUSINESS_UNITS;
};